var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{staticClass:"TheModal",attrs:{"active":_vm.open},on:{"close":_vm.handleClose}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }